import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white" data-id="element-186">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-188">
          <div data-id="element-189">
            <div className="flex items-center" data-id="element-190">
              <BookOpenIcon className="h-8 w-8 text-blue-400" data-id="element-191" />
              <span className="ml-2 text-xl font-bold" data-id="element-192">Young Mind</span>
            </div>
            <p className="mt-2 text-gray-400 text-sm" data-id="element-193">
              Reset your well-being and regain vitality with our transformative
              guide.
            </p>
          </div>
          <div data-id="element-194">
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase" data-id="element-195">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-4" data-id="element-196">
              <li data-id="element-197">
                <a href="#buy-now" className="text-base text-gray-300 hover:text-white" data-id="element-198">
                  Get Your Copy
                </a>
              </li>
              <li data-id="element-199">
                <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-200">
                  About the Author
                </a>
              </li>
              <li data-id="element-201">
                <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-202">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-203">
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase" data-id="element-204">
              Legal
            </h3>
            <ul className="mt-4 space-y-4" data-id="element-205">
              <li data-id="element-206">
                <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-207">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-208">
                <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-209">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-210">
                <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-211">
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-800 pt-8" data-id="element-212">
          <p className="text-base text-gray-400 text-center" data-id="element-213">
            &copy; {new Date().getFullYear()} Young Mind. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}